import type { appConfig } from './types';

const isServer = typeof window === 'undefined';
const isProduction = process.env.ENVIRONMENT === 'production';

/**
 * Any values in here have the possibility of being exposed to the user
 * in the DOM / JS Bundles. do not add private keys to this config file.
 */
const CONFIG: appConfig = {
  ENVIRONMENT: process.env.ENVIRONMENT || 'development',
  SERVICES: {
    //
    // Auth0
    AUTH0: {
      DOMAIN: process.env.AUTH0_DOMAIN || 'accounts.staging.stockx.io',
      CLIENTID: process.env.AUTH0_CLIENT_ID || '',
      RESPONSETYPE: 'token id_token',
      SCOPE: 'openid profile',
      HOST: process.env.HOST || 'http://localhost:3000',
      AUDIENCE:
        process.env.AUTH0_AUDIENCE_HOSTNAME || 'gateway.staging.stockx.io',
      CONNECTION: process.env.AUTH0_CONNECTION || 'staging',
      REGION: process.env.REGION || 'us-east-1',
    },

    //
    // Hyperwallet
    HYPERWALLET: {
      URL: isProduction
        ? 'https://accounts.stockx.com/samlp/kDVZFrW0R1e56g7t1UOPyDXTGJmzS652'
        : 'https://accounts.staging.stockx.io/samlp/VJzJnmNMv9D7vEukrY8yAP2IeWpwMSHM',
      MFA_URL: isProduction
        ? 'https://accounts.stockx.com/samlp/kDVZFrW0R1e56g7t1UOPyDXTGJmzS652?acr_values=http%3A%2F%2Fschemas.openid.net%2Fpape%2Fpolicies%2F2007%2F06%2Fmulti-factor'
        : 'https://accounts.staging.stockx.io/samlp/VJzJnmNMv9D7vEukrY8yAP2IeWpwMSHM?acr_values=http%3A%2F%2Fschemas.openid.net%2Fpape%2Fpolicies%2F2007%2F06%2Fmulti-factor',
    },

    //
    // Adyen
    ADYEN: {
      ADYEN_CSS_URL_VERSION: '5.33.0',
      ADYEN_CSS_SHA_VALUE:
        'sha384-86hqIixzFjIoRoaNYg9pd4mtpn3HtgJmrpYiyTv+3DaGPF70VnRUbtK7MKLTLRd9',
    },

    //
    // Affirm
    AFFIRM: {
      AFFIRM_PUBLIC_API: isProduction ? '9VEEHL5W9WO7VH7K' : 'SK0PP1DEWGQTQWUA',
      AFFIRM_SCRIPT: isProduction
        ? 'https://cdn1.affirm.com/js/v2/affirm.js'
        : 'https://cdn1-sandbox.affirm.com/js/v2/affirm.js',
    },

    //
    // DataDog Rum
    DATA_DOG_RUM: {
      APP_ID:
        process.env.DATADOG_RUM_APP_ID ||
        'e55d867b-402d-4f90-b747-6f42f9ccc6c4',
      CLIENT_TOKEN:
        process.env.DATADOG_RUM_CLIENT_TOKEN ||
        'pube74e41f9775d0c47e40393c3a40d1d8c',
    },

    //
    // Google Tag Manager
    GTM: {
      KEY: isProduction ? 'GTM-NSNVQXK' : 'GTM-W9P9XS5',
    },

    //
    // Google Analytics
    GA: {
      KEY: isProduction ? 'UA-67038415-1' : 'UA-67038415-2',
    },

    //
    // Segment
    SEGMENT: {
      KEY: isProduction
        ? 'U4EdztkiXl51BC4pC5M2a0jzBSE9ULlU'
        : 'LgqDvLNWgTINWEc3fxwbZ6puvLDzohPn',
      ALIAS: isProduction ? 'gx7SHXSQlu' : 'YIM6ATHkEk',
      CDN_URL: 'https://evs.cdp.stockx.com',
    },

    //
    // Contentstack
    CONTENTSTACK: {
      ENVIRONMENT: isProduction ? 'production' : 'staging',
      STACK_API_KEY: process.env.CONTENTSTACK_STACK_API_KEY || '',
    },

    //
    // One Trust
    ONETRUST: {
      ENABLED: true,
      DOMAIN: isProduction
        ? '137eafd0-59e4-44a7-a76f-e26ddbde8f33'
        : '137eafd0-59e4-44a7-a76f-e26ddbde8f33-test',
      SCRIPT_SRC: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
      AUTOBLOCK_SCRIPT_SRC: isProduction
        ? 'https://cdn.cookielaw.org/consent/137eafd0-59e4-44a7-a76f-e26ddbde8f33/OtAutoBlock.js'
        : 'https://cdn.cookielaw.org/consent/137eafd0-59e4-44a7-a76f-e26ddbde8f33-test/OtAutoBlock.js',
    },

    //
    // QuantumMetric
    QUANTRUMMETRIC: {
      SCRIPT_SRC: isProduction
        ? 'https://cdn.quantummetric.com/qscripts/quantum-stockx.js'
        : 'https://cdn.quantummetric.com/qscripts/quantum-stockx-test.js',
    },
    VIPER: {
      DOMAIN: isProduction
        ? 'https://pro.stockx.com'
        : 'https://viper.staging.stockx.io',
    },

    // Rokt Ads
    ROKT: {
      ACCOUNT_ID: '2957813298232595485',
    },
  },
  APP: {
    DEFAULT_LANGUAGE: process.env.DEFAULT_LANGUAGE || 'en-US',
    DEFAULT_COUNTRY: process.env.DEFAULT_COUNTRY || 'US',
    HELP_PAGE_URL:
      process.env.HELP_PAGE_URL || 'https://iron.staging.stockx.io/help',
  },
  FLAGS: {
    SEO: {
      REDIRECT_ADIDAS_YEEZY_TO_YEEZY:
        process.env.REDIRECT_ADIDAS_YEEZY_TO_YEEZY || 'false',
    },
  },
};

export default isServer ? CONFIG : window.appConfig;
